
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetStaticProps } from "next"
import Head from "next/head"

import useNewProducts from "@/graphql/hooks/useNewProducts"
import getFilters from "@/graphql/requests/getFilters"
import SEO from "@/meta/SEO"
import { GoogleAnalytics } from "@/services/GA4/GoogleAnalytics"
import Default from "@/templates/Default"
import { FansiKindExtended } from "@/ts/Global"
import FilterGroup from "@/ts/interfaces/global/FilterGroup"
import useStaticProducts from "@/views/products/functions/useStaticProducts"
import ProductsGridView from "@/views/products-grid"

const FANSI_KIND: FansiKindExtended = "new"

function NewProductsPage({ staticFilters }: { staticFilters: FilterGroup }) {
  const { filters } = useStaticProducts({
    staticFilters,
  })

  const { products, isLoading, count, maxPrice } = useNewProducts()

  if (!filters) return null

  return (
    <>
      <Head>
        <title>Nowe produkty | fansi.pl</title>
        <SEO description="Premiery autorskich produktów i kolekcji od najlepszych Twórców, z którymi zadbasz o swój umysł, ciało i duszę, dom i bliskich. Najnowsze trendy, super okazje!" />
      </Head>
      <GoogleAnalytics />
      <ProductsGridView
        products={products}
        isLoading={isLoading}
        count={count}
        filters={filters}
        maxPrice={maxPrice}
        fansiKind={FANSI_KIND}
      />
    </>
  )
}

NewProductsPage.Layout = Default

 const _getStaticProps: GetStaticProps = async () => {
  const staticFilters = await getFilters({ onlyCreators: false })
  return { props: { staticFilters }, revalidate: 1 }
}

export default NewProductsPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/products/new/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  